import { Component, ViewChild } from '@angular/core';

import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from './base/services/custom-toast-service';
import { DynamicLoadComponentDirective } from './directives/common/dynamic-load-component.directive';


import { Router } from '@angular/router';


import { UnifiedAuthService } from './services/yoklama/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  @ViewChild(DynamicLoadComponentDirective, { static: true })
  dynamicLoadComponentDirective?: DynamicLoadComponentDirective;
  version = '0';

  showModal = false;
  constructor(
    public authService: UnifiedAuthService,
    private toastrService: CustomToastrService,
    private router: Router,


  ) {
    authService.identityCheck();



  }

  closeModal() {
    this.showModal = false;

  }
  signOut() {
    localStorage.removeItem('accessToken');

    this.toastrService.message('Oturum kapatılmıştır!', 'Oturum Kapatıldı', {
      messageType: ToastrMessageType.Warning,
      position: ToastrPosition.TopRight,
    });
  }



}
